<template>
    <el-dialog
            class="dialog-custom"
            :visible.sync="dialogVisible"
            :show-close="false"
            :modal="false"
            top="37px"
            @open="open"
            width="441px">
        <div class="info">
            <div class="left">
                <i class="el-icon-alter el-icon-success"></i>
            </div>
            <div class="right">
                <div class="title">Submission successful</div>
                <div class="note">We have received your application and will process it and contact you as soon as possible.</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['dialogVisible'],
    methods: {
        open() {
          setTimeout(() => {
             this.updateVisible()
          }, 2000);
        },
        updateVisible() {
            this.$emit("update:dialogVisible", false);
        }
    }
}
</script>

<style scoped lang="scss">
.dialog-custom {
    /deep/ .el-dialog {
        border-radius: 10px;
        border: 1px solid #6A88FF;
        overflow: hidden;
    }

    /deep/ .el-dialog__header,
    /deep/ .el-dialog__body,
    /deep/ .el-dialog__footer {
        padding: 0;
    }

    .info {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        position: relative;
        width: 100%;
        height: 113px;
        padding: 12px 24px;
        background-color: #ffffff;

        > img {
            width: 100%;
            object-fit: contain;
        }
    }

    .left {
        width: 40px;
    }

    .right {
        flex: 1;
        .title {
            font-size: 16px;
            font-weight: 700;
            line-height: 30px;
            color: #1A1824;
            margin-bottom: 8px;
        }

        .note {
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            color: #1a1824;
            text-transform: capitalize;
        }
    }

    .el-icon-alter {
        width: 24px;
        height: 24px;
        font-size: 24px;
        line-height: 30px;
        color: #3aef9d;
        background-color: #ffffff;
    }
}
</style>